import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { AccessRoleDeserializer } from "./access-role-deserializer.service";
import { ApiCreateInvitationsRequest } from "../apiClient/models";
import { InvitationsClient, UsersClient } from "../apiClient/services";
import { InvitationDetails } from "../domain/invitation";
import { cacheWithExpiry } from "../shared/types/observable";

@Injectable({
  providedIn: "root",
})
export class InvitationsService {
  private readonly _pendingInvitations$: Observable<InvitationDetails[]>;
  private readonly _cachingPendingInvitations$: Observable<InvitationDetails[]>;

  constructor(
    private readonly invitationsClient: InvitationsClient,
    private readonly usersClient: UsersClient,
    private readonly accessRoleDeserializer: AccessRoleDeserializer,
  ) {
    this._pendingInvitations$ = this.usersClient.getSelfInvitations().pipe(
      map((apiInvitation) => {
        return apiInvitation.map((x) => InvitationDetails.from(x, this.accessRoleDeserializer));
      }),
    );

    this._cachingPendingInvitations$ = cacheWithExpiry(() => this._pendingInvitations$, 5000).observable$;
  }

  public getPendingInvitations$(skipCache = false): Observable<InvitationDetails[]> {
    if (!skipCache) {
      return this._cachingPendingInvitations$;
    } else {
      return this._pendingInvitations$;
    }
  }

  public createInvitations$(body: ApiCreateInvitationsRequest): Observable<InvitationDetails[]> {
    return this.invitationsClient.createInvitations({ body }).pipe(
      map((apiResponse) => {
        return apiResponse.createdInvitations.map((x) => InvitationDetails.from(x, this.accessRoleDeserializer));
      }),
    );
  }

  public acceptInvitation$(invitationId: number): Observable<void> {
    return this.invitationsClient.acceptInvitation({ invitationId });
  }

  public rejectInvitation$(invitationId: number): Observable<void> {
    return this.invitationsClient.rejectInvitation({ invitationId });
  }

  public deleteInvitation$(invitationId: number): Observable<void> {
    return this.invitationsClient.deleteInvitation({ invitationId });
  }
}
